import Swiper, { Autoplay, Pagination } from 'swiper';
import { $events } from '../../helpers/events';
import Component from '../../classes/Component';

const topSliderSelector = '.js-top-slider-group'
const bottomSliderSelector = '.js-bottom-slider-group'
const cartSliderSelector = '.js-cart-slider-group'
const swiperPaginationTopSelector = '.js-swiper-pagination-top'

const prevTopButtonSelector = '.js-prev-slider-button-top'
const nextTopButtonSelector = '.js-next-slider-button-top'

const prevBottomButtonSelector = '.js-prev-slider-button-bottom'
const nextBottomButtonSelector = '.js-next-slider-button-bottom'

export default function () {

    return new Component({
        name: 'carousel',
        requiredTargets: [
            topSliderSelector,
            bottomSliderSelector,
            prevTopButtonSelector,
            nextTopButtonSelector,
            prevBottomButtonSelector,
            nextBottomButtonSelector,
        ],
        onInit() {
            new Swiper(cartSliderSelector, {

                spaceBetween: 10,

                breakpoints: {
                    575: {
                        slidesPerView: '3.2',
                    },

                    440: {
                        slidesPerView: '2.9',
                    },

                    380: {
                        slidesPerView: '2.3',
                    },

                    280: {
                        slidesPerView: '2',
                    }
                }
            })

            const swiperTop = new Swiper(topSliderSelector, {
                modules: [Pagination, Autoplay],

                autoplay: {
                    delay: 3000,
                },

                spaceBetween: 20,

                navigation: true,

                breakpoints: {
                    767: {
                        slidesPerView: '1',
                    },

                    280: {
                        slidesPerView: '1',
                    }
                },

                pagination: {
                    el: swiperPaginationTopSelector,
                    type: 'bullets',
                    // dynamicBullets: true,
                    // dynamicMainBullets: 3,
                    bulletActiveClass: 'swiper-pagination-bullet-active swiper-pagination-bullet-top-active',
                    bulletClass: 'swiper-pagination-bullet swiper-pagination-bullet-top'
                },


            })

            const swiperBottom = new Swiper(bottomSliderSelector, {
                slidesPerView: '1',
                spaceBetween: 20,

                navigation: {
                    nextEl: nextBottomButtonSelector,
                    prevEl: prevBottomButtonSelector,
                }
            })

            $events.delegate.on('click', nextTopButtonSelector, () => {
                swiperTop.slideNext()
            })

            $events.delegate.on('click', prevTopButtonSelector, () => {
                swiperTop.slidePrev()
            })

            $events.delegate.on('click', nextBottomButtonSelector, () => {
                swiperBottom.slideNext()
            })

            $events.delegate.on('click', prevBottomButtonSelector, () => {
                swiperBottom.slidePrev()
            })
        },
        onDestroy() {
            console.log('carousel')
        },
    })

}
